/**
 * Safely strips HTML tags from a string and returns plain text.
 *
 * Uses the browser's native DOMParser to avoid polynomial ReDoS, incomplete
 * sanitization via nested tag evasion (<sc<x>ript>), and double-decode issues
 * that arise when HTML entities are decoded after a regex tag-strip.
 *
 * Falls back to a simple regex for Node / Jest environments where DOMParser is
 * unavailable — safe for length checks and logging but not for HTML rendering.
 */
export function stripHtmlToText(html: string): string {
  if (!html) return '';
  if (typeof DOMParser === 'undefined') {
    return html
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  return (new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '')
    .replace(/\u00A0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
